export const timeRange = [
    {
        key: "1",
        value: "1 day"
    },
    {
        key: "15",
        value: "15 days"
    },
    {
        key: "31",
        value: "31 days"
    },
]